/* =========================================================================
   NUTROVATE product detail page
   Framework free and independent of Horizon's private modules. All product
   data arrives from Liquid on window.NV_PDP, so nothing here is hard coded
   to a single product. Cart writes go through the public Cart AJAX API,
   which is a stable contract a theme update cannot break.
   ========================================================================= */
(function () {
  'use strict';
  if (window.__nvPdpInit) return;
  window.__nvPdpInit = true;

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  var CFG = window.NV_PDP || {};
  var CART_ADD = (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add.js';
  var CART_URL = (window.Theme && window.Theme.routes && window.Theme.routes.cart_url) || '/cart';
  var CURRENCY = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';

  function money(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en',
        { style: 'currency', currency: CURRENCY }).format(cents / 100);
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  /* ---------------------------------------------------------------- toast */
  var toastEl, toastT;
  function toast(msg, link) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'pd-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = link
      ? msg + ' <a href="' + CART_URL + '" style="color:var(--yellow);text-decoration:underline;text-underline-offset:3px">View cart</a>'
      : msg;
    toastEl.classList.add('is-on');
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3200);
  }

  function syncCartUI(cart) {
    var count = cart && typeof cart.item_count === 'number' ? cart.item_count : null;
    if (count !== null) {
      $$('.cart-bubble').forEach(function (b) { b.classList.toggle('visually-hidden', count === 0); });
      $$('[ref="cartBubbleCount"],[data-nv-cart-count]').forEach(function (el) {
        el.textContent = count > 99 ? '99+' : String(count);
        el.classList.toggle('is-on', count > 0);
        el.classList.toggle('hidden', count === 0);
      });
    }
    ['cart:update', 'cart:refresh', 'cart:change'].forEach(function (n) {
      document.dispatchEvent(new CustomEvent(n, { bubbles: true, detail: { cart: cart, source: 'nv-pdp' } }));
    });
  }

  function postCart(items, label, btn) {
    var restore = btn ? btn.innerHTML : null;
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.textContent = 'Adding...'; }
    return fetch(CART_ADD, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.body && (res.body.description || res.body.message)) || 'Could not add to cart');
        return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        syncCartUI(cart);
        if (!window.__nvCartDrawer) toast(label + ' added', true);
      })
      .catch(function (err) { toast(err.message || 'Something went wrong'); })
      .finally(function () {
        if (btn) { btn.removeAttribute('aria-disabled'); btn.innerHTML = restore; }
      });
  }

  /* ------------------------------------------------------------- gallery */
  function gallery() {
    var root = $('.pd-gal'); if (!root) return;
    var track = $('.pd-gal__track', root), thumbs = $('.pd-gal__thumbs', root),
        count = $('.pd-gal__count', root);
    var slides = $$('.pd-gal__slide', track);
    if (!slides.length) return;
    var idx = 0, raf;

    function setIdx(i) {
      idx = i;
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
      $$('.pd-gal__thumb', thumbs).forEach(function (t, n) {
        t.setAttribute('aria-current', n === i ? 'true' : 'false');
      });
    }
    function goTo(i) {
      if (!slides[i]) return;
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      setIdx(i);
    }
    $$('.pd-gal__thumb', thumbs).forEach(function (t, i) {
      t.addEventListener('click', function () { goTo(i); });
    });
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== idx && slides[i]) setIdx(i);
      });
    });
    var prev = $('.pd-gal__nav--prev', root), next = $('.pd-gal__nav--next', root);
    if (prev) prev.addEventListener('click', function () { goTo(Math.max(0, idx - 1)); });
    if (next) next.addEventListener('click', function () { goTo(Math.min(slides.length - 1, idx + 1)); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(Math.min(slides.length - 1, idx + 1)); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(Math.max(0, idx - 1)); }
    });
    setIdx(0);
  }

  /* Liquid does not expose a selling plan's delivery interval as a field, so
     it is read out of the plan name and option text and matched to the supply
     the shopper picked. A 90 day supply must bill on the 3 month plan. */
  function planMonths(txt) {
    var t = String(txt || '').toLowerCase();
    var w = t.match(/(\d+)\s*week/);
    if (w) return Math.max(1, Math.round(parseInt(w[1], 10) / 4));
    var m = t.match(/(\d+)\s*month/);
    if (m) return parseInt(m[1], 10);
    var y = t.match(/(\d+)\s*year/);
    if (y) return parseInt(y[1], 10) * 12;
    return 1;
  }

  function planFor(days) {
    var list = (CFG && CFG.sellingPlans) || [];
    if (!list.length) return CFG.sellingPlanId || null;
    for (var i = 0; i < list.length; i++) {
      if (planMonths(list[i].t) * 30 === Number(days)) return list[i].id;
    }
    return list[0].id;
  }

  /* ------------------------------------------------------------- buy box */
  function buybox() {
    var box = $('.pd-buy'); if (!box || !CFG.tiers) return;
    var state = { days: CFG.tiers[0].days, mode: null };
    var byDays = {};
    CFG.tiers.forEach(function (t) { byDays[t.days] = t; });

    /* One time takes the tier discount. Subscribe takes a flat rate off list
       and never stacks with it, so no cart can beat the larger of the two. */
    function quote(days, mode) {
      var t = byDays[days], list = CFG.listCents * t.jars;
      var off = (mode === 'sub') ? CFG.subRate : t.off;
      return { list: list, now: Math.round(list * (1 - off)), off: off, tier: t };
    }

    function render() {
      var mode = state.mode, effective = mode || 'once';
      var q = quote(state.days, effective);
      var sub = quote(state.days, 'sub'), once = quote(state.days, 'once');

      var sp = $('[data-sub-price]'); if (sp) sp.textContent = money(sub.now);
      var sw = $('[data-sub-was]'); if (sw) sw.textContent = money(sub.list);
      var op = $('[data-once-price]'); if (op) op.textContent = money(once.now);
      var ow = $('[data-once-was]');
      if (ow) { if (once.off > 0) { ow.hidden = false; ow.textContent = money(once.list); } else ow.hidden = true; }

      CFG.tiers.forEach(function (t) {
        var e = quote(t.days, effective);
        var pe = $('[data-tier-price="' + t.days + '"]'); if (pe) pe.textContent = money(e.now);
        var pd = $('[data-tier-per="' + t.days + '"]');
        if (pd) pd.textContent = money(Math.round(e.now / t.days)) + ' / day';
        var sv = $('[data-tier-save="' + t.days + '"]');
        if (sv) {
          var saved = e.list - e.now;
          if (saved <= 0) { sv.hidden = true; }
          else {
            sv.hidden = false;
            /* Rule of 100: percent below the threshold, currency above it */
            sv.textContent = e.list >= 10000
              ? 'Save ' + money(saved).replace(/\.00$/, '')
              : 'Save ' + Math.round(e.off * 100) + '%';
          }
        }
      });

      var now = $('#nvPrice'); if (now) now.textContent = money(q.now);
      var was = $('#nvPriceWas');
      if (was) { if (q.off > 0) { was.hidden = false; was.textContent = money(q.list); } else was.hidden = true; }
      var per = $('#nvPricePer');
      if (per) per.textContent = money(Math.round(q.now / state.days)) + ' per day';

      /* ROSCA: the recurring terms are body copy under the selector, never a tooltip */
      var terms = $('#nvTerms'), tt = $('[data-terms-txt]');
      if (terms && tt) {
        if (mode === 'sub') {
          terms.hidden = false;
          tt.textContent = money(sub.now) + ' every ' + state.days + ' days, starting today. ' +
            (CFG.termsSub || 'Skip, delay or cancel in one click from your account.');
        } else if (mode === 'once') {
          terms.hidden = false;
          tt.textContent = 'A single charge of ' + money(once.now) + '. ' +
            (CFG.termsOnce || 'Nothing recurring, nothing to cancel.');
        } else terms.hidden = true;
      }

      var hint = $('[data-sup-hint]');
      if (hint) hint.textContent = mode === 'sub' ? (CFG.hintSub || 'How often it arrives')
                                                 : (CFG.hintOnce || 'How long it lasts');

      var ship = $('#nvShipLine');
      if (ship && CFG.freeShipCents) {
        /* The threshold is set in the shop's own currency. When a visitor is
           served another market's currency the two are not comparable, so show
           the plain threshold rather than a converted and wrong distance. */
        var sameCurrency = !CFG.shopCurrency || CFG.shopCurrency === CURRENCY;
        if (sameCurrency) {
          var gap = CFG.freeShipCents - q.now;
          ship.innerHTML = gap > 0
            ? '<b>' + CFG.shipLabel + '.</b> This order is ' + money(gap) + ' away.'
            : '<b>' + CFG.shipLabel + '.</b> This order qualifies.';
        } else {
          ship.innerHTML = '<b>' + CFG.shipLabel + '.</b> Threshold is in ' + CFG.shopCurrency + '.';
        }
      }

      var meta = $('#nvStickyMeta');
      if (meta) meta.textContent = money(q.now) + ' • ' + state.days + ' day supply' +
        (mode === 'sub' ? ' • subscription' : '');
      var ss = $('#nvStickySupply'); if (ss) ss.value = String(state.days);
    }

    $$('[data-supply]').forEach(function (r) {
      r.addEventListener('change', function () { state.days = parseInt(r.value, 10); render(); });
    });
    $$('[data-mode]').forEach(function (r) {
      r.addEventListener('change', function () { state.mode = r.value; render(); });
    });
    var ss = $('#nvStickySupply');
    if (ss) ss.addEventListener('change', function () {
      state.days = parseInt(this.value, 10);
      var t = $('[data-supply][value="' + state.days + '"]');
      if (t) t.checked = true;
      render();
    });

    $$('[data-atc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!state.mode && $('[data-mode]')) {
          toast(CFG.pickMode || 'Choose subscribe or one time first');
          var block = $('[data-mode]').closest('.pd-block');
          if (block) block.scrollIntoView({ behavior: 'smooth', block: 'center' });
          $('[data-mode]').focus();
          return;
        }
        var t = byDays[state.days];
        var item = { id: t.variantId || CFG.variantId, quantity: t.jars };
        if (state.mode === 'sub') {
          var pid = planFor(state.days);
          if (pid) item.selling_plan = pid;
        }
        postCart([item], CFG.title || 'Item', btn);
      });
    });

    render();
  }

  /* ------------------------------------------------------------ sticky bar
     A bar that only scrolls you back to the button produced no measurable
     lift in the one A/B test with disclosed sample sizes. This one carries
     the price, the supply selector and a working button. ----------------- */
  function sticky() {
    var bar = $('#nvSticky'), pad = $('#nvStickyPad'), anchor = $('.pd-cta');
    if (!bar || !anchor) return;
    var on = false, raf = 0;
    function sync() {
      var below = anchor.getBoundingClientRect().bottom < 8;
      if (below === on) return;
      on = below;
      bar.classList.toggle('is-on', below);
      bar.setAttribute('aria-hidden', below ? 'false' : 'true');
      if (pad) pad.classList.toggle('is-on', below);
    }
    function queue() {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = 0; sync(); });
    }
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    sync();
  }

  /* ----------------------------------------------------------------- FAQ */
  function faq() {
    $$('.pd-faq__q').forEach(function (btn) {
      var pan = btn.nextElementSibling;
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        pan.style.height = open ? '0px' : pan.firstElementChild.offsetHeight + 'px';
      });
    });
    window.addEventListener('resize', function () {
      $$('.pd-faq__q').forEach(function (b) {
        if (b.getAttribute('aria-expanded') === 'true') {
          var p = b.nextElementSibling;
          p.style.height = p.firstElementChild.offsetHeight + 'px';
        }
      });
    });
  }

  /* ------------------------------------------------------------- reviews
     Rendered by Liquid from section blocks. This only filters, sorts and
     searches what is already in the DOM, so the content is crawlable and
     works with JavaScript disabled. ------------------------------------ */
  function reviews() {
    var list = $('#nvRevList'); if (!list) return;
    var none = $('#nvRevNone'), sortEl = $('#nvRevSort'), searchEl = $('#nvRevSearch');
    var items = $$('.pd-r', list);
    var star = 0;

    $$('.pd-bar').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = parseInt(b.getAttribute('data-star'), 10);
        star = (star === v) ? 0 : v;
        $$('.pd-bar').forEach(function (x) {
          x.setAttribute('aria-pressed', parseInt(x.getAttribute('data-star'), 10) === star ? 'true' : 'false');
        });
        draw();
      });
    });

    function draw() {
      var q = ((searchEl && searchEl.value) || '').trim().toLowerCase();
      var mode = (sortEl && sortEl.value) || 'recent';
      var shown = items.filter(function (el) {
        if (star && parseInt(el.getAttribute('data-star'), 10) !== star) return false;
        if (q && el.textContent.toLowerCase().indexOf(q) < 0) return false;
        return true;
      });
      var order = shown.slice();
      if (mode === 'helpful') order.sort(function (a, b) { return num(b, 'data-help') - num(a, 'data-help'); });
      if (mode === 'high') order.sort(function (a, b) { return num(b, 'data-star') - num(a, 'data-star'); });
      if (mode === 'low') order.sort(function (a, b) { return num(a, 'data-star') - num(b, 'data-star'); });
      if (mode === 'recent') order.sort(function (a, b) { return num(a, 'data-order') - num(b, 'data-order'); });
      items.forEach(function (el) { el.hidden = shown.indexOf(el) < 0; });
      order.forEach(function (el) { list.appendChild(el); });
      if (none) none.hidden = shown.length > 0;
    }
    function num(el, attr) { return parseInt(el.getAttribute(attr), 10) || 0; }

    if (sortEl) sortEl.addEventListener('change', draw);
    if (searchEl) searchEl.addEventListener('input', draw);

    $$('.pd-r__help', list).forEach(function (b) {
      b.addEventListener('click', function () {
        var n = b.querySelector('b');
        if (!n) return;
        n.textContent = String(parseInt(n.textContent, 10) + 1);
        b.disabled = true; b.style.opacity = '.55';
      });
    });
    draw();
  }

  /* ----------------------------------------------------------- cross sell */
  function crossSell() {
    $$('[data-add-variant]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-add-variant');
        if (!id) { toast('This product is not available yet'); return; }
        var ids = id.split(',').filter(Boolean);
        postCart(ids.map(function (v) { return { id: parseInt(v, 10), quantity: 1 }; }),
          btn.getAttribute('data-add-label') || 'Item', btn);
      });
    });
  }

  /* -------------------------------------------------------------- reveal */
  function reveal() {
    var els = $$('.nv-rv');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    els.forEach(function (e) { io.observe(e); });
  }

  function boot() { gallery(); buybox(); sticky(); faq(); reviews(); crossSell(); reveal(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
